import { TranslationObject } from '../i18n/translation';

const namespace = 'menu';

const translations: TranslationObject = {
  dashboard: { id: `${namespace}.dashboard`, nb: 'Dashbord', en: 'Dashboard' },
  calendar: {
    id: `${namespace}.calendar`,
    nb: 'Praksiskalender',
    en: 'Practice calendar',
  },
  myinstitution: {
    id: `${namespace}.myinstitution`,
    nb: 'Min institusjon',
    en: 'My institution',
  },
  myorganization: {
    id: `${namespace}.myorganization`,
    nb: 'Min organisasjon',
    en: 'My organization',
  },
  students: {
    id: `${namespace}.students`,
    nb: 'Studenter',
    en: 'Students',
  },
  practiceplaces: {
    id: `${namespace}.practiceplaces`,
    nb: 'Praksissteder',
    en: 'Practice places',
  },
  settings: {
    id: `${namespace}.settings`,
    nb: 'Innstillinger',
    en: 'Settings',
  },
  login: { id: `${namespace}.login`, nb: 'Logg inn', en: 'Log in' },
  logout: { id: `${namespace}.logout`, nb: 'Logg ut', en: 'Log out' },
  sync: {
    id: `${namespace}.sync`,
    nb: 'Synkronisering',
    en: 'Synchronization',
  },
  practicePlaceSearch: {
    id: `${namespace}.practicePlaceSearch`,
    nb: 'Praksisstedssøk',
    en: 'Practice place search',
  },
  vurdering: {
    id: `${namespace}.vurdering`,
    nb: 'Vurdering',
    en: 'Evaluation',
  },
  mineBrukere: {
    id: `${namespace}.mineBrukere`,
    nb: 'Mine brukere',
    en: 'My users',
  },
  lagStudiestedbruker: {
    id: `${namespace}.lagStudiestedbruker`,
    nb: 'Lag studiestedbruker',
    en: 'Generate UH user',
  },
  inviterSystembruker: {
    id: `${namespace}.inviterSystembruker`,
    nb: 'Inviter systembruker',
    en: 'Invite admin user',
  },
};

export default translations;
